import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { IssuanceContributingItems } from 'codegen';

import { columns } from './lib';

export const IssuanceItemTable = ({
  snapId,
  expandedId,
  issuanceId,
  transactionId,
}: {
  snapId?: number;
  expandedId?: number;
  issuanceId: number;
  transactionId?: number;
}) => {
  const { data, loading } = useGetRequest<IssuanceContributingItems>({
    url: `/snaps/${snapId}/transactions/${transactionId}/issuances/${issuanceId}/items`,
    options: {
      ready: !!(expandedId && issuanceId && expandedId === issuanceId),
      refreshDeps: [expandedId, issuanceId],
    },
  });

  const dataSource = data?.items;

  return (
    <MilesTable
      size='small'
      rowKey='id'
      loading={loading}
      columns={columns}
      dataSource={dataSource}
    />
  );
};
